import Logo from "../assets/logo.png";

const images = {
  Logo,
};

export default images;
